import './FilterBar.css'
import Option from './Option'

const FilterOption = ({option,setOptions,options})=>{
    function handleRemove(){
       let filtered = options.filter(el=>el!==option)
       setOptions(filtered)
    }
    return (
        <div className="filterOption">
            <Option option={option}/>
            <div className="delete" onClick={handleRemove}>
                <img src="./images/icon-remove.svg" alt="delete"/>
            </div>
        </div>
    )
}

const FilterBar = ({options,setOptions})=>{

    return (
      
            <div className="filterBar">
                <div className="filters">
                    {
                        options.map(el=>
                            <FilterOption option={el} setOptions={setOptions} options={options} key={el}/>
                        )
                    }
                </div>
                <div className="button">
                    <span className="clear" onClick={()=> setOptions([])}>
                        Clear
                    </span>
                </div>
            </div>
        
    )

}
export default FilterBar